import React, { useEffect } from 'react';
import { FormField } from '../../types'
import { useRef, useState } from 'react';
import { useOutsideAlerter } from '../../useOutsideAlerter';
import Spinner from '../Spinner';
import useApi from '../../api';
import DocPanel from '../DocPanel';
import { set } from 'lodash';
import ModalEditor from '../../ui/editor/ModalEditor';
import ClosedEditor from '../../ui/editor/ClosedEditor';
import { v4 as uuidv4 } from 'uuid';

interface StringProps {
    docId: string | undefined;
    field: any;
    updateSchema: any;
    path: string[];
    mode?: string
}


const RichText: React.FC<StringProps> = ({ docId, field, updateSchema, path, mode }) => {
    const [modalVisible, setModalVisible] = useState(false);


    return (
     modalVisible ? (
        <ModalEditor content={field.value} docId={docId} field={field} updateSchema={updateSchema} path={path} mode={mode} modalVisible={modalVisible} setModalVisible={setModalVisible} />

     ) : (
        <ClosedEditor content={field.value} docId={docId} field={field} updateSchema={updateSchema} path={path} mode={mode} setModalVisible={setModalVisible} />
     )

    );
};

export default RichText;
